<template>
    <div class="footer-holder">
        <img class="logo" src="/logo.svg" />
        <div class="website-title" v-text="title"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'games.nozkok.com',
        },
    },
};
</script>

<style scoped>
.footer-holder {
    width: 100%;
    height: 180px;
    background-color: #014c78;
    border-top: 15px solid #037fc8;
    text-align: center;
}

.logo {
    height: 80px;
    margin-left: auto;
    margin-right: auto;
}

.website-title {
    width: 100%;
    text-align: center;
    font-size: 23px;
    font-weight: bold;
    line-height: 60px;
}
</style>
